import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/BasicLayout.vue'
import staticRouter from './static'
import { useUserStore } from '@/stores'
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import { capitalizeFirstLetter } from '@/utils/utils'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [

    // {
    // path: '/',
    // name: 'Layout',
    // component: Layout,
    // redirect: '/index',
    //   children: [
    //     {
    // path: '/index',
    // name: 'Index',
    // component: () => import('@/views/home/home-index.vue'),
    // meta: {
    //   title: '首页',
    //   icon: 'House',
    //   keepAlive: true,
    // },
    //     },
    //     {
    //       path: '/project-list',
    //       name: 'ProjectList',
    //       component: () => import('@/views/project/project-list.vue'),
    //       meta: {
    //         title: '项目信息',
    //         icon: 'DashboardFilled',
    //         keepAlive: true,
    //       },
    //     },
    //     {
    //       path: '/project-statistics',
    //       name: 'ProjectStatistics',
    //       component: () => import('@/views/project/project-statistics.vue'),
    //       meta: {
    //         title: '数据统计',
    //         icon: 'DashboardFilled',
    //         keepAlive: true,
    //       },
    //     },
    //     {
    //       path: '/custorm-list',
    //       name: 'CustormList',
    //       component: () => import('@/views/custorm/custorm-list.vue'),
    //       meta: {
    //         title: '单位客户信息',
    //         icon: 'DashboardFilled',
    //         keepAlive: true,
    //       },
    //     },
    //   ],
    // },
    ...staticRouter,
  ],
})

// 动态加载后端菜单并添加路由

const viewsComponent = import.meta.glob('../views/**/*.vue')
const addDynamicRoutes = () => {
  const auth = useUserStore()
  try {
    // 定义菜单映射方法
    const mapMenuToRoutes = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const route: any = [
        {
          path: '/',
          name: 'Layout',
          component: Layout,
          redirect: '/index',
          children: [
            {
              path: '/index',
              name: 'Index',
              component: () => import('@/views/home/home-index.vue'),
              meta: {
                title: '首页',
                icon: 'House',
                keepAlive: true,
              },
            },
            // {
            //   path: '/devices',
            //   name: 'devices',
            //   meta: {
            //     title: '首页',
            //     icon: 'House',
            //     keepAlive: true,
            //   },
            //   component: () => import('@/views/basic/devices/devices-manage.vue'),
            // }
          ],
        },
      ]

      const data = auth.userRoleFlat.filter((m) => m.type == 'menu' && m.parentId != 0) // 后端获取的菜单数据
      Object.entries(viewsComponent).forEach(([path, component]) => {
        data.forEach((e) => {
          if (path.includes(e.path)) {
            route[0].children.push({
              path: e.path,
              name: capitalizeFirstLetter(e.path.slice(1)),
              component,
              meta: {
                title: e.name,
                icon: e.icon,
                keepAlive: true,
              },
            }) // 添加路由
          }
        })
      })

      auth.routeData = route
      return route
    }
    // 转换菜单数据为路由配置
    const dynamicRoutes = mapMenuToRoutes()


    // 添加动态路由
    dynamicRoutes.forEach((route: RouteRecordRaw) => {
      router.addRoute(route) // 添加顶级路由
    })


    // 添加404兜底路由（必须最后添加）
    router.addRoute({
      path: '/:catchAll(.*)',
      redirect: '/404',
    })

    return dynamicRoutes
  } catch (error) {
    console.error('加载菜单失败', error)
    return []
  }
}

const isAuthenticated = () => {
  return localStorage.getItem('token') ? true : false
}

let hasRoutes = false

router.beforeEach(async (to, from, next) => {
  // 用户已登录且尚未加载动态路由
  if (isAuthenticated() && !hasRoutes) {

    try {
      await addDynamicRoutes()
      hasRoutes = true

      // 跳转到目标路由（解决刷新白屏）
      // console.log('去哪里')
      next({ ...to, replace: true })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      // 处理错误
      next('/login')
    }
  } else {

    // 正常流程
    if (to.path === '/login') {
      document.title = '昕晟环保销售管理系统'
      hasRoutes = false
      next()
    } else if (!isAuthenticated()) {
      // console.log('isAuthenticated:', isAuthenticated())
      document.title = '昕晟环保销售管理系统'
      hasRoutes = false
      next('/login')
    } else {
      Nprogress.start()

      if (to.meta.title) {
        document.title = to.meta.title as string
      }
      next()
    }
  }
})

// 全局路由守卫
router.beforeResolve((to, from, next) => {

  // 在这里可以添加全局的路由守卫逻辑
  // 例如检查用户是否登录、权限等
  // 如果需要，可以在这里进行权限验证
  // 如果验证通过，调用 next() 继续路由导航
  // 如果验证不通过，可以重定向到登录页面或其他页面
  next()
})

router.afterEach(() => {
  Nprogress.done()
})

export default router
